import React from "react"
const Video = ({ videoSrcURL, videoTitle, ...props }) => (
  <>
    <iframe
      loading="lazy"
      width="500" height="300"
      src={videoSrcURL}
      title={videoTitle}
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture;"
      frameBorder="0"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
      allowFullScreen
      autoPlay
      loop
      muted
      playsinline
      webkit-playsinline
    />
  </>
)
export default Video
